import { down, up } from 'styled-breakpoints'

export const onExtraSmallScreen = () => up('xs')
export const onSmallScreen = () => up('sm')
export const onMediumScreen = () => up('md')
export const onLargeScreen = () => up('lg')
export const onExtraLargeScreen = () => up('xl')
export const onXXLargeScreen = () => up('xxl')
export const onSmallScreenAndBelow = () => down('sm')
